import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VApp, { attrs: { id: "appointment-form-app-desktop" } }, [
    _c(
      "div",
      { staticClass: "b-container" },
      [
        _vm._t("title"),
        _vm._v(" "),
        _vm.$slots["club-screen"]
          ? _c(
              VCard,
              { staticClass: "py-8", attrs: { elevation: "1" } },
              [_vm._t("club-screen")],
              2
            )
          : _vm.$slots["state-screen-flat"]
          ? _vm._t("state-screen-flat")
          : _vm.$slots["state-screen"]
          ? _c(
              VCard,
              { attrs: { elevation: "1", height: "614" } },
              [_vm._t("state-screen")],
              2
            )
          : _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c(
                  VCard,
                  {
                    staticClass: "flex-grow-1 py-10",
                    attrs: { elevation: "1", "min-height": "422" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "layout-dekstop-content mx-auto d-flex flex-column gr-6",
                        style: { width: "456px" },
                      },
                      [_vm._t("main-content")],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  VCard,
                  {
                    staticClass: "flex-shrink-0 align-self-start ml-6",
                    attrs: { width: "360", elevation: "1" },
                  },
                  [_vm._t("aside-content")],
                  2
                ),
              ],
              1
            ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }